const queryString = require("query-string");
const search = location.href.split("?")[1] || "";
const parsed = queryString.parse(search);
const appKey = parsed["key"] || "";
const tag = parsed["tag"] || "";
const test = parsed["test"];
const group = parsed["group"];
const user = parsed["user"];
const disableMakingCall = parsed["dmc"]; // 是否禁用外呼
const disableIncomingRinging = parsed["dir"]; // 是否禁用振铃
const disableTabTitleChange = parsed["dtc"]; // 是否禁用标签标题变更
const disableMultipleTabs = parsed["dmt"]; // 是否禁止多页签同屏
window.query = parsed;

// /?key=&tag&test=true&group=&user=
console.log("parsed : ", parsed, appKey);
window.addEventListener("load", (event) => {
  // pathname: "/verify"
  if (location.pathname && location.pathname.includes("verify")) {
    return;
  }
  const Cosee = window.Cosee || window["cosee"];
  const options = {
    crypto: {
      cipherType: "AES",
      passphrase: "RONKXGC6",
      needEncryptScreenData: false,
      needEncryptUserGroup: false,
    },
    disableMultipleTabs: true,
  };
  if (test === "true") {
    if (disableMakingCall) {
      options.disableMakingCall = true;
    }
    if (disableIncomingRinging) {
      options.disableIncomingRinging = true;
    }
    if (disableTabTitleChange) {
      options.disableTabTitleChange = true;
    }
    if (disableMultipleTabs) {
      options.disableMultipleTabs = true;
    }
    Cosee.init(appKey, options);
    Cosee.setBizTagName(tag);
    user && Cosee.setUserName(user);
    group && Cosee.setUserGroup(group);
  } else {
    // 测试 appKey ba90ca401f9611eda81beb7dc6c17ed6
    Cosee.init("8867b4905a6411ec98322f2f97e11e7a", options);
    if (tag) {
      Cosee.setBizTagName(tag);
    } else {
      Cosee.setBizTagName("峰畅科技官网");
    }
    user && Cosee.setUserName(user);
    group && Cosee.setUserGroup(group);
  }
});
